import * as Model from "../model";

import type * as Repository from "../../../_repository";

type Props = {
	// 検索日
	searchDate: string;
	// オプションリスト
	optionPmsActiveListQueryData: Repository.Query.QueryData.OptionPmsList.OptionPmsActiveListQueryData;

	optionPmsColorListQueryData: Repository.Query.QueryData.OptionPmsColorListQueryData;
};

export const PrintGuestListForOptionPms = ({
	searchDate,
	optionPmsActiveListQueryData,
	optionPmsColorListQueryData,
}: Props) => {
	/**
	 * 初期化
	 */
	const {
		//
		viewData,
	} = Model.UseCase.useInitialized({
		searchDate,
		optionPmsActiveListQueryData,
		optionPmsColorListQueryData,
	});

	return (
		<div className="space-y-3">
			<div className="space-y-2">
				<p className="text-sm">予約者リスト</p>

				<div className="flex justify-between">
					<div className="flex items-center gap-x-2">
						<p className="text-sm">
							<b>検索日:</b> {viewData.searchDateText}
						</p>

						<p className="text-sm">
							<b>検索結果:</b> {viewData.listCountText}
						</p>
					</div>
				</div>
			</div>

			{/* テーブル */}
			<div>
				<table className="w-full  text-xs">
					<thead>
						<tr className="border [&>th]:border-r">
							<th className="w-32 max-w-32">オプション名</th>
							<th className="w-32 max-w-32">時間</th>
							<th className="w-32 max-w-32">氏名</th>
							<th className="w-32 max-w-32">電話番号</th>
							<th className="w-32 max-w-32">決済方法</th>
							<th className="w-32 max-w-32">メモ</th>
						</tr>
					</thead>
					<tbody className="w-full">
						{viewData.rowDataList.map((row, index) => (
							<tr key={index} className="border [&>td]:border-r [&>td]:p-1">
								<td
									className="w-32 max-w-32 underline"
									style={{ textDecorationColor: row.option.color }}
								>
									{row.option.nameText}
								</td>
								<td className="w-32 max-w-32">{row.atText}</td>
								<td className="w-32 max-w-32">{row.guestNameText}</td>
								<td className="w-32 max-w-32">{row.guestTelText}</td>
								<td className="w-32 max-w-32">{row.paymentMethodText}</td>
								<td className="w-32 max-w-32">{row.memo}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};
